import { useContext } from "react";

import { ContextLanguage } from "./language.context";

export const useContextLanguage = () => useContext(ContextLanguage);
